<template>
  <div class="menu">
      <div class="menu-icon" @click="show = true"></div>

      <van-popup v-model="show" position="right" class="menu-popup" style="z-index: 99999">
      <div class="close" @click="handleCloseClick"></div>
      <div style="clear: both"></div>
      <div class="sectionbox">
        <a class="sli" href="#/about?type=web" @click="goSubPage('about')">{{ localize.string_aboutus }}</a>
        <a class="sli" href="#/safety?type=web" @click.prevent="goSubPage('safety')">{{ localize.string_safety }}</a>
        <a class="sli" href="#/community?type=web" @click.prevent="goSubPage('community')">{{ localize.string_community }}</a>
        <a class="sli" href="#/privacy?type=web" @click.prevent="goSubPage('privacy')">{{ localize.string_privacy }}</a>
        <a class="sli" href="#/eula?type=web" @click.prevent="goSubPage('eula')">{{ localize.string_eula }}</a>
        <a class="sli" :href="contactUid" target="_blank">{{ localize.string_contact_us }}</a>
        <a class="sli" href="#/faq?type=web" @click.prevent="goSubPage('faq')">{{ localize.string_faq }}</a>
        <a class="sli" v-if="hasLogin" href="#/setAccount?type=web" @click.prevent="goSubPage('setAccount')">{{ localize.setting_account }}</a>
        <a class="sli" v-if="!hasLogin" href="/omegle">Omegle</a>
        <div class="sline" v-if="hasLogin"></div>
        <div class="sli" @click="loginOut" v-if="hasLogin">{{ localize.btn_sign_out }}</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { logoutApi } from '@/api/common'
import { removeToken } from '@/utils/auth'
export default {
  name: 'menu-popup',
  data() {
    return {
      show: false,
      contactUid: ''
    }
  },
  computed: {
    ...mapState({
      meUserInfo: (state) => state.common.meUserInfo,
      localize: (state) => state.common.localize,
    }),
    hasLogin() {
      return !!this.meUserInfo
    }
  },
  methods: {
    handleCloseClick() {
      this.show = false
    },
    goSubPage(path) {
      const uid = this.meUserInfo?.user_id || this.meUserInfo?.id
      const url = path == 'faq' && uid ? `${path}?uid=${uid}&type=web` : `${path}?type=web`
      this.$router.push(url)
    },
    async loginOut() {
      this.$showLoading()
      try {
        //清除指定localStorage
        await logoutApi()
        removeToken()
        localStorage.removeItem('meUserInfo')
        localStorage.removeItem('loginUserInfo')
        localStorage.removeItem('token')
        localStorage.removeItem('analytics_user_properties')
        this.$nextTick(() => {
          var url = window.location.href
          var splitUrl = url.split('#')[0]
          var jumpUrl = splitUrl.substring(0, splitUrl.length)
          window.location.replace(jumpUrl)
        })
      } catch (error) {
        this.$hideLoading()
      }
    }
  },
  mounted() {
    if (this.meUserInfo) {
        this.contactUid = 'mailto:hello@monkey.app?body=%0a%0d%0a%0d %0a%0d%0a%0d %0a%0d%0a%0d --------- %0a user:' + this.meUserInfo.user_id
      } else {
        this.contactUid = 'mailto:hello@monkey.app?body='
      }
  }
}
</script>

<style lang="less" scoped src="./style.less"></style>
